/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engine_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't load the scoring engine, so Archon can't start. Reload to retry." |
*
* @param {Engine_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const engine_load_error = /** @type {((inputs?: Engine_Load_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engine_Load_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger le moteur de score, Archon ne peut donc pas démarrer. Rechargez pour réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar el motor de puntuación, así que Archon no puede iniciarse. Recarga para reintentar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar o motor de pontuação, então o Archon não pode iniciar. Recarregue para tentar novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare il motore di punteggio, quindi Archon non può avviarsi. Ricarica per riprovare.")
	return /** @type {LocalizedString} */ ("Couldn't load the scoring engine, so Archon can't start. Reload to retry.")
});